<template>
  <span>
    <crud-layout-search :params="params" :interface="nmInterface" :id="id" :page="page" clean-layout class="contact-client" />
  </span>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import ContactPersonPage from '../person/person/ContactPersonPage'
import _ from 'lodash'

const { page, CrudLayoutSearch } = JtCrud
@Component({
  mixins: [page],
  name: 'ContactClient',
  components: { CrudLayoutSearch, ContactPersonPage },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class ContactClient extends Vue {
  get nmInterface () {
    return this.interface
  }

  get page () {
    return ContactPersonPage
  }
}
export default ContactClient
</script>
<style lang="stylus" scoped>
 @import '~quasar-variables';

.contactPersonForms {
    height: 250px !important;
  }

  .contact-client{
    .buttons-top-crud{
      padding: 10px 14px;
    }
    .q-table th, .q-table td{
      padding: 0px 10px !important;
    }

    .table-crud .jt-datatable {
      height: 63vh !important;
      padding-bottom: 20px;
    }
  }

  @media only screen and (max-height: 750px) {
    .contact-client{
    .table-crud .jt-datatable {
      padding-bottom: 0px;
    }
  }
}

</style>
